import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import StandardModal from 'modals/StandardModal';
import Spinner from 'components/Spinner';
import Alert from 'view/components/Alert';
import { useQueueMonitor } from 'data/repositories/queueMonitorRepository';
import PropertyStatsCard from './components/PropertyStatsCard';
import JobBreakdownTable from './components/JobBreakdownTable';
import PropertyTrendsSection from './components/PropertyTrendsSection';
import { closeModal } from 'data/reducers/modalReducer';

const PropertyStatsModal = ({ options }) => {
	const dispatch = useDispatch();
	const { property } = options || {};
	const { actions, propertyJobStats, propertyJobTrends } = useQueueMonitor();

	const [activeTab, setActiveTab] = useState('stats');
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);

	// Load data when modal opens
	useEffect(() => {
		const loadData = async () => {
			if (!property?.id) {
				setError('Property ID is required');
				setIsLoading(false);
				return;
			}

			setIsLoading(true);
			setError(null);

			try {
				actions.getPropertyJobStats({
					propertyId: property.id,
				});

				actions.getPropertyJobTrends({
					propertyId: property.id,
					days: 7,
				});
			} catch (err) {
			} finally {
				setIsLoading(false);
			}
		};

		loadData();
	}, [property?.id, actions]);

	const handleClose = () => {
		dispatch(closeModal());
	};

	const renderTabContent = () => {
		if (isLoading) {
			return (
				<div className="text-center py-5">
					<Spinner />
					<p className="text-muted mt-3">Loading property statistics...</p>
				</div>
			);
		}

		if (error) {
			return <Alert color="danger">{error}</Alert>;
		}

		switch (activeTab) {
			case 'stats':
				return (
					<div>
						<PropertyStatsCard data={propertyJobStats} />
						<div className="mt-4">
							<h5 className="mb-3">BIS Jobs Breakdown</h5>
							<JobBreakdownTable
								jobs={propertyJobStats?.bisJobs?.breakdown || []}
								type="BIS"
							/>
						</div>
						<div className="mt-4">
							<h5 className="mb-3">Open Data Jobs Breakdown</h5>
							<JobBreakdownTable
								jobs={propertyJobStats?.odJobs?.breakdown || []}
								type="OD"
							/>
						</div>
					</div>
				);

			case 'trends':
				return <PropertyTrendsSection data={propertyJobTrends} />;

			default:
				return null;
		}
	};

	return (
		<StandardModal
			title={
				<div>
					<div className="h5 mb-1">Property Job Statistics</div>
					<div className="text-muted small">
						{property?.address || 'Loading...'}
						{property?.bin && (
							<span className="ms-2">(BIN: {property.bin})</span>
						)}
					</div>
				</div>
			}
			size="xl"
			closeOnOutsideClick
			closeLabel="Close"
			onClose={handleClose}
			hideConfirm
		>
			<div className="property-stats-modal">
				{/* Tabs */}
				<ul className="nav nav-tabs mb-4">
					<li className="nav-item">
						<button
							className={`nav-link ${activeTab === 'stats' ? 'active' : ''}`}
							onClick={() => setActiveTab('stats')}
						>
							Today's Stats
						</button>
					</li>
					{/* <li className="nav-item">
						<button
							className={`nav-link ${activeTab === 'trends' ? 'active' : ''}`}
							onClick={() => setActiveTab('trends')}
						>
							Trends (7 Days)
						</button>
					</li> */}
				</ul>

				{/* Tab Content */}
				<div className="tab-content">{renderTabContent()}</div>
			</div>
		</StandardModal>
	);
};

export default PropertyStatsModal;
